<template>
	<div>
		<v-expansion-panels v-model="activePanel" accordion class="panel-stepper-sale">
			<v-form
				style="width: 100%"
				:ref="`formLayout-${conf.ticketType.id}`"
				lazy-validation
				v-for="conf in getTicketsToSale"
				:key="conf.ticketType.id"
			>
				<v-expansion-panel
					style="border: 1px solid rgba(0, 0, 0, 0.1); border-radius: 8px"
					class="mt-2"
					v-for="ticket in conf.tickets.filter((t) => t.form !== null)"
					:key="ticket.ticketId"
					@change="() => handleClickPanel(`${conf.ticketType.id}${ticket.ticketId}`)"
				>
					<v-expansion-panel-header>
						<h3 class="fcolor-extra-dark expansionPanel">
							{{ conf.ticketType.name }}
						</h3>

						<template v-slot:actions>
							<p class="mb-0 d-flex align-center fcolor-medium-dark">
								{{
									activePanel !== undefined && `${conf.ticketType.id}${ticket.ticketId}` === identificatorActivePanel
										? $t('formlayoutcomponent.collapseForm')
										: $t('formlayoutcomponent.openForm')
								}}
							</p>
							<v-icon> $expand </v-icon>
						</template>
					</v-expansion-panel-header>
					<v-expansion-panel-content :eager="true">
						<v-container class="px-8">
							<form-headers-layout
								:formHeaderLayout="ticket.form.formHeaderLayout"
								:id="`${conf.ticketType.id}${ticket.ticketId}`"
								@formHeaderUpdate="(data) => handleFormHeaderUpdate(data, conf.ticketType.id, ticket.ticketId)"
							/>
							<form-items-layout
								v-model="ticket.form.groups"
								:id="`${conf.ticketType.id}${ticket.ticketId}`"
								@formItemsData="(data, dataValue) => handleFormItemsData(data, dataValue, conf.ticketType.id, ticket.ticketId)"
                                @checkItemsGroup="handleCheckboxValue"
							/>
							<!--
							<v-row>

									<v-col col="12" md="8" lg="6">
										<promotional-code />
									</v-col>
								 <v-btn color="success" class="mr-4" @click="() => validate(conf.ticketType.id)"> Validate </v-btn>
							</v-row>
							-->
							<v-row>
								<v-col cols="12">
									<p class="font-weight-medium mb-0">{{ $t('title_receive_information') }}</p>
									<v-radio-group @change="(val) => handleReceiveInformation(val, conf.ticketType.id, ticket.ticketId)">
										<v-radio :label="$t('accept_receive_information')" :value="true"></v-radio>
										<v-radio :label="$t('cancel_receive_information')" :value="false"></v-radio>
									</v-radio-group>
								</v-col>
							</v-row>
						</v-container>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-form>
		</v-expansion-panels>
		<div class="d-flex justify-end pt-4">
			<v-row class="d-flex justify-end pt-4">
				<v-col cols="12" md="6" v-if="!loginRequired">
					<v-autocomplete
						class="d-flex align-center"
						dense
						v-model="selectedBuyer"
                        auto-select-first
						:items="buyerList"
						:label="$t('steppersale.selectticketsend')"
						:hide-details="true"
					>
						<template v-slot:append-outer>
							<v-slide-x-reverse-transition mode="out-in">
								<v-btn :disabled="!selectedBuyerAvailable" color="info" @click="handleNextStep">
									<span class="mr-2 pl-2"> {{ $t('steppersale.nextbutton') }} </span>
								</v-btn>
							</v-slide-x-reverse-transition>
						</template>
					</v-autocomplete>
				</v-col>
				<v-col v-else cols="12" md="6" class="d-flex justify-end">
					<v-btn color="info" @click="handleNextStep">
						<span class="mr-2 pl-2"> {{ $t('steppersale.nextbutton') }} </span>
					</v-btn>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import FormHeadersLayout from './FormHeadersLayout.vue';
import FormItemsLayout from './FormItemsLayout.vue';
import PromotionalCode from './PromotionalCode.vue';

export default {
	components: { 'form-items-layout': FormItemsLayout, 'form-headers-layout': FormHeadersLayout, 'promotional-code': PromotionalCode },
	data() {
		return {
			activePanel: null,
			identificatorActivePanel: null,
			selectedBuyer: '',
			radioGroup: '',
			ticket: ''
            //allItemsFilled: null
		};
	},
	computed: {
		...mapGetters(['getTicketsToSale', 'loginRequired']),
		selectedBuyerAvailable() {
			return this.buyerList.some((buyer) => buyer === this.selectedBuyer);
		},
		buyerList() {
			const selectedConf = this.getTicketsToSale.map((conf) => conf.tickets.filter((ticket) => ticket.form)).flat();
			const selectedRows = selectedConf.map((ticket) =>
				ticket.form.formHeaderLayout.rows
					.map((row) => row.columns.filter((col) => col.attribute === 'person_email').map((col) => col.value))
					.flat(3)
			);
            if (selectedRows.length >= 1) {
				 selectedRows.forEach(element => {
					if (element[0] != null) {
                 		this.selectedBuyer = element[0];
						return '';
					}
				 });
            }
			return selectedRows.flat().filter((val) => !!val);
		},
		allReceiveInformationTouched() {
			const selectedConf = this.getTicketsToSale.map((conf) => conf.tickets.filter((ticket) => ticket.form)).flat();
			const allreceivInformationValue = selectedConf.map((ticket) =>
				ticket.form.formHeaderLayout.rows
					.map((row) => row.columns.filter((col) => col.attribute === 'receive_information').map((col) => col.value))
					.flat(3)
			);
			return allreceivInformationValue.flat().every((val) => val === true || val === false);
		}
	},
	methods: {
		...mapActions(['UPDATE_FORM_HEADER_IN_SELECTED_DATA', 'UPDATE_GROUP_ITEMS_IN_SELECTED_DATA', 'UPDATE_RECEIVE_INFORMATION_IN_SELECTED_DATA']),
		handleClickPanel(val) {
			this.identificatorActivePanel = val;
		},
		handleNextStep() {
			if (!this.validateAllForm()) {
				this.$toast.error(this.$t('steppersale.errorfillrequireddata'));
				setTimeout(function () {  
					// Encuentra todos los campos de entrada en la página
					const inputs = document.querySelectorAll('.error--text');

					// Encuentra el índice del campo de entrada actualmente enfocado
					const currentInputIndex = Array.from(inputs).findIndex(input => input === document.activeElement);

					// Calcula el índice del próximo campo de entrada
					const nextInputIndex = (currentInputIndex + 1) % inputs.length;

					inputs[nextInputIndex].scrollIntoView({ behavior: 'smooth' });
					
					// Opcional: Enfoca el próximo campo de entrada
					inputs[nextInputIndex].focus();
				}, 1000)
				return '';
			}

			let checksValidation = false;
			let groups = [];
			this.getTicketsToSale.forEach(conf => {
				this.$refs[`formLayout-${conf.ticketType.id}`][0].$children.forEach(ticket => {
					ticket.$children[1].$children[1].$children.forEach(element => {
						checksValidation = false;
						if (Object.keys(element.checkBoxValue).length == 0) {
							if (element.checkBox != null) {
								for (var checkBox in element.checkBox) {
									if (element.checkBox.hasOwnProperty(checkBox)) {
										let value = element.checkBox[checkBox];
										if(value == "1"){
											checksValidation = true;
										}
									}
								}
							}
						} else {
							for (var checkBoxValue in element.checkBoxValue) {
								if (element.checkBoxValue.hasOwnProperty(checkBoxValue)) {
									let value = element.checkBoxValue[checkBoxValue];
									if(value == "1"){
										checksValidation = true;
									}
								}
							}
						}
						groups[element._uid] = checksValidation;
					});
				});
			});
			if (groups.includes(false)) {
				this.$toast.error(this.$t('steppersale.errorselectdata'));
				
				setTimeout(function () {  
					// Encuentra todos los campos de entrada en la página
					const inputs = document.querySelectorAll('.form-items');

					// Encuentra el índice del campo de entrada actualmente enfocado
					const currentInputIndex = Array.from(inputs).findIndex(input => input === document.activeElement);

					// Calcula el índice del próximo campo de entrada
					const nextInputIndex = (currentInputIndex + 1) % inputs.length;

					// Desplaza la página al próximo campo de entrada
					//inputs[nextInputIndex].scrollIntoView({ behavior: 'smooth' });
					inputs[nextInputIndex].scrollIntoView();
					window.scrollBy(0, -10);

					// Opcional: Enfoca el próximo campo de entrada
					inputs[nextInputIndex].focus();
				}, 100)
				
				return '';
			}
			if (this.noDuplicateEmailsInFormByTicketConf()) {
				this.$toast.error(this.$t('steppersale.errorduplicateemails'));
				return '';
			}
			if (!this.loginRequired) {
				this.$emit('selectedBuyer', this.selectedBuyer);
			}
			if (!this.allReceiveInformationTouched) {
				this.$toast.error(this.$t('steppersale.errorreceivedata'));
				return '';
			}

			this.$emit('handleNextStep');
		},
		validateAllForm() {
			return this.getTicketsToSale.every((conf) => this.$refs[`formLayout-${conf.ticketType.id}`][0].validate() === true);
		},
		noDuplicateEmailsInFormByTicketConf() {
			const emailsByTicketType = this.getTicketsToSale.map((conf) => {
				const ticketType = conf.ticketType.id;
				const ticketsForms = conf.tickets.filter((ticket) => ticket.form !== null).map((ticket) => ticket.form.formHeaderLayout);

				const emails = ticketsForms
					.map((form) => form.rows.map((row) => row.columns.filter((col) => col.attribute === 'person_email')).flat())
					.flat()
					.map((email) => email.value);

				return { ticketType, emails };
			});

			return !emailsByTicketType.every((e) => {
				const selectedEmails = e.emails.length;
				const selectedEmailsWithoutDuplicated = new Set(e.emails).size;
				return selectedEmails === selectedEmailsWithoutDuplicated;
			});
		},
		handleFormHeaderUpdate(rows, ticketTypeId, ticketId) {
			this.UPDATE_FORM_HEADER_IN_SELECTED_DATA({ rows, ticketTypeId, ticketId });
		},
		handleFormItemsData(formItemsData, formItemsDataValue, ticketTypeId, ticketId) {
			this.UPDATE_GROUP_ITEMS_IN_SELECTED_DATA({ formItemsData, formItemsDataValue, ticketTypeId, ticketId });
		},
		handleReceiveInformation(value, ticketTypeId, ticketId) {
			this.UPDATE_RECEIVE_INFORMATION_IN_SELECTED_DATA({ value, ticketTypeId, ticketId });
		},
        handleCheckboxValue(checked) {
            // Establecemos en allItemsFilled que estan todos los grupos con un item al menos seleccionado
            //this.allItemsFilled = checked;
        }
	},
	mounted() {
		setTimeout(function () {  
			var panel = document.querySelectorAll('.expansionPanel')[0];
			panel.click();
		}, 200)
	}
};
</script>

<style>
.v-expansion-panel:not(:first-child)::after {
	border-top: none;
}
</style>
